import React, { useEffect, useState } from 'react';
import { Link, useHistory, useParams } from 'react-router-dom';

import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableBody from '@mui/material/TableBody';
import Button from '@mui/material/Button';

import Alert, { useAlert } from 'components/snacks/Alert';
import CollapseServers from "components/collapse/Servers"

import { iranServerColumns, numSeperator, } from 'utils/DataBase';
import { getCategory } from 'utils/Data';
import Loading from 'layout/Loading';
import { axiosInstance } from 'api/Api';

const Server = () => {
  const history = useHistory();
  const { category } = useParams();
  const categoryItem = getCategory(category);
  const [loading, setLoading] = useState(false);
  const [irServers, setIrServers] = useState([]);
  const [euServers, setEuServers] = useState([]);
  const [tabCategory, setTabCategory] = useState('ir');
  const [result, setResult] = useState([]);
  const [showTabs, setShowTabs] = useState(true);

  const alert_timeout = 10000;
  const alertStore = useAlert(alert_timeout);
  const serverName = useParams().category;
  console.log(serverName);

  useEffect(() => {
    if (!categoryItem.status) {
      return history.push('/404-not-found-page/');
    }
    if (history.location.pathname === '/servers/hetzner' ||
      history.location.pathname === '/servers/datacrunch' ||
      history.location.pathname === '/servers/digital-ocean' ||
      history.location.pathname === '/servers/contabo') {
      setTabCategory('eu');
      setShowTabs(false);
    }
    else if (history.location.pathname === '/servers/email') {
      setTabCategory('ir');
      setShowTabs(true);
    } else {
      setShowTabs(true);
    }
    const apiLink = `/get-${categoryItem.category.slug}`;
    setLoading(true);
    axiosInstance()
      .get(apiLink)
      .then((res) => {
        res.data.product_ir = [];
        try {
          setIrServers(res.data?.products_ir ? res.data.products_ir : []);
          setEuServers(res.data?.product_eu ? res.data.product_eu : []);
        } catch {
          setEuServers([]);
        }
      })
      .catch( () =>
      {
        alertStore.AddAlert({
          key: '400',
          message: 'مشکلی پیش آمده است‌، لطفا دوباره امتحان کنید',
          severity: 'error',
          auto_hide: true
        });
      })
      .finally(() => {
        setLoading(false);
      });
  }, [category]);

  useEffect(() => {
    if (irServers.length || euServers.length) {
      calcResult(tabCategory);
    }
  }, [irServers, euServers]);

  const calcResult = (tab) => {
    switch (tab) {
      case 'ir': {
        setResult(irServers.map((server) => ({ ...server, locale: 'ir' })));
        break;
      }
      case 'eu': {
        setResult(euServers.map((server) => ({ ...server, locale: 'eu' })));
        break;
      }
      default: {
        setResult(irServers.map((server) => ({ ...server, locale: 'ir' })));
      }
    }
  };

  const changeTab = (cat) => {
    setTabCategory(cat);
    calcResult(cat);
  };

  const removeStorage = (row, locale) => {
    setLoading(true);
    axiosInstance().get(`/order?product_id=${row}`)
        .then((res) => {

          if (res.data.status === 200) {
            localStorage.removeItem('product');
            localStorage.removeItem('validList');
            localStorage.removeItem('attrList');
            localStorage.removeItem('sum');

            return history.push('/services/server-iran/server-order',  {
              id: row,
              locale: locale
            });
          } else {
            alertStore.AddAlert({
              key: '400',
              message: res.data.msg,
              severity: 'error',
              auto_hide: true
            });
          }
        })
        .catch((err) => {
          alertStore.AddAlert({
            key: '400',
            message: 'ارتباط با سرور با خطا مواجه شد',
            severity: 'error',
            auto_hide: true
          });
        }).finally(()=>{

      setLoading(false);
    });

  };
  const [isLimited, setIsLimited] = useState(false);
const handleUnlimitedTraffic = (e) =>{
  setIsLimited(e.target.checked)
}

const removeLocalStorage = (url, locale) => {
  localStorage.removeItem('product');
  localStorage.removeItem('validList');
  localStorage.removeItem('attrList');
  localStorage.removeItem('sum');
  return history.push(url, {locale: locale});
}
  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <section className="normal-shadow bg-white p-5 rounded">
          <h1 className={'h3'}>{categoryItem.category.name}</h1>
          <hr />
          <div className={'d-flex align-items-center justify-content-between mb-4'}>
            {showTabs && (
                <>
                  <div className="d-flex align-items-center" style={{gap: '10px'}}>
                    <button
                        className={`category-tab d-flex justify-content-center align-items-center ${
                            tabCategory === 'ir' ? 'active' : ''
                        }`}
                        onClick={() => changeTab('ir')}
                    >
                      <img
                          src="/assets/media/svg/iran-flag.svg"
                          alt="iran-flag"
                          width={30}
                          height={30}
                      />
                      <span className="ms-5">ایران</span>
                    </button>
                    <button
                        className={`category-tab d-flex justify-content-center align-items-center ${
                            tabCategory === 'eu' ? 'active' : ''
                        }`}
                        onClick={() => changeTab('eu')}
                    >
                      <img
                          src="/assets/media/svg/european-flag.svg"
                          alt="european-flag"
                          width={30}
                          height={30}
                      />
                      <span className="ms-5">اروپا</span>
                    </button>
                  </div>
                </>
            )}
            <label className={'checkbox-btn'} for={'limitTraffic'}>
              <input id={'limitTraffic'} type={'checkbox'} className={'d-none'} onChange={(e) => handleUnlimitedTraffic(e)}/>
              <span>ترافیک نامحدود</span>
            </label>
          </div>

          {result.length ?(
            <>
              <TableContainer className="d-none d-md-block">
                <Table stickyHeader aria-label="sticky table">
                  <TableHead sx={{ BackgroundColor: '#eaeaea' }}>
                    <TableRow>
                      {iranServerColumns.map((column, columnIndex) => (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          className={column?.class}
                          style={{
                            fontFamily: 'yekan',
                            fontSize: '1em',
                            background: '#0993c6',
                            color: '#fff',
                            whiteSpace: 'nowrap'
                          }}
                        >
                          {column.id === 'price' && serverName === "datacrunch" ? 'هزینه روزانه' : column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(isLimited ? result.filter((i)=> i.fair_traffic === 0) : result).map((row, index) => {
                      return (
                        <TableRow
                          hover
                          role="checkbox"
                          tabIndex={-1}
                          key={index}
                          style={{
                            backgroundColor: index % 2 === 0 ? '#f0f6ff' : ''
                          }}
                        >
                          {iranServerColumns.map((column) => {
                            const value = row[column.id];
                            return (
                              <TableCell
                                key={column.id}
                                align={column.align}
                                className={column?.class}
                                sx={{ fontFamily: 'yekan !important' }}
                              >
                                {column.id === 'id' && <span>{index + 1}</span>}
                                {column.id === 'order' && (
                                  // <Link
                                  //   to={{
                                  //     pathname:
                                  //       '/services/server-iran/server-order',
                                  //     state: {
                                  //       id: row['id'],
                                  //       locale: row.locale
                                  //     }
                                  //   }}
                                  // >
                                    <Button
                                        onClick={()=>removeLocalStorage(`/services/server-iran/server-order?id=${row.id}`, row.locale)}
                                      variant={'contained'}
                                      color={'primary'}
                                      className={'yekan-font'}
                                    >
                                      سفارش
                                    </Button>
                                  // </Link>
                                )}
                                {column.id === 'price' &&
                                  (row['price'] ? (
                                    <div>
                                      <span className={'me-1'}>
                                        {numSeperator(value)}
                                      </span>
                                      <span>تومان</span>
                                    </div>
                                  ) : (
                                    <span>---</span>
                                  ))}
                                {column.id !== 'order' &&
                                  column.id !== 'price' &&
                                  column.id !== 'id' && <span>{value}</span>}
                              </TableCell>
                            );
                          })}
                        </TableRow>
                      );
                    })}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* mobile items */}
              {result.map((row, index) => {
                  return (
                    <>
                      <div className="d-md-none" key={`user-ticket-${index}`}>
                        <CollapseServers
                            onClick={()=>removeLocalStorage(`/services/server-iran/server-order?id=${row.id}`, row.locale)}
                          item={row}
                          columns={iranServerColumns}
                          order={removeStorage}
                        />
                      </div>
                    </>
                  );
                })}
            </>
          ) : (
            <div className={'alert alert-warning mt-4 text-center'}>
              سروری یافت نشد
            </div>
          )}
        </section>
      )}
      {
        <Alert
          alerts={alertStore.alert}
          close={alertStore.RemoveAlert}
          timeout={alert_timeout}
        />
      }
    </>
  );
};

export default Server;
